import { ACCESS_RIGHTS } from "@/constants/accessRights";

// ─── Procurement Menu ─────────────────────
// Phase structure follows the Revised IRR sequencing exactly:
//   Phase 1 — Pre-Procurement        (Sec. 7, 17)
//   Phase 2 — BAC & Advertisement    (Sec. 11, 21, 22, 25)
//   Phase 3 — Bid Evaluation         (Sec. 30, 32, 34)
//   Phase 4 — Award & Contract       (Sec. 37, 39, 41)
//   Phase 5 — Implementation         (Sec. 63, 68)
// ─────────────────────────────────────────────────────────────────────────────
 
export function buildProcurementMenuItems(state) {
    var isProcPreProcurement     = state.isProcPreProcurement;
    var isProcBacManagement      = state.isProcBacManagement;
    var isProcAdvertisement      = state.isProcAdvertisement;
    var isProcBidEvaluation      = state.isProcBidEvaluation;
    var isProcPostQualification  = state.isProcPostQualification;
    var isProcAwardContract      = state.isProcAwardContract;
    var isProcImplementation     = state.isProcImplementation;

    var setIsProcPreProcurement    = state.setIsProcPreProcurement;
    var setIsProcBacManagement     = state.setIsProcBacManagement;
    var setIsProcAdvertisement     = state.setIsProcAdvertisement;
    var setIsProcBidEvaluation     = state.setIsProcBidEvaluation;
    var setIsProcPostQualification = state.setIsProcPostQualification;
    var setIsProcAwardContract     = state.setIsProcAwardContract;
    var setIsProcImplementation    = state.setIsProcImplementation;
    var setIscurrentState          = state.setIscurrentState;

    return [
        {
            id: "procurement",
            label: "Procurement",
            icon: "ri-file-list-3-line",
            link: "/#",
            subItems: [

                // ── Dashboard ────────────────────────────────────────────────
                {
                    id: "proc-dashboard",
                    label: "Dashboard",
                    icon: "ri-dashboard-2-line",
                    link: "/procurement/dashboard",
                    parentId: "procurement",
                    permissionTypeId: [],
                },

                {
                    id: "proc-masterlist",
                    label: "Project Masterlist",
                    icon: "ri-dashboard-2-line",
                    link: "/procurement/projects",
                    parentId: "procurement",
                    permissionTypeId: [],
                },

                // ── PHASE 1 — Pre-Procurement ────────────────────────────────
                // Sec. 7  — APP preparation
                // Sec. 17 — Pre-procurement conference (for complex contracts)
                // ────────────────────────────────────────────────────────────
                {
                    id: "proc-pre-procurement",
                    label: "Pre-Procurement",
                    icon: "ri-file-edit-line",
                    link: "/#",
                    parentId: "procurement",
                    isChildItem: true,
                    stateVariables: isProcPreProcurement,
                    click: function (e) {
                        e.preventDefault();
                        setIsProcPreProcurement(!isProcPreProcurement);
                        setIscurrentState("ProcPreProcurement");
                    },
                    childItems: [
                        {
                            // Sec. 7 — End-user unit prepares PPMP
                            id: "proc-ppmp",
                            label: "PPMP",
                            link: "/procurement/pre-procurement/ppmp",
                            permissionTypeId: [],
                        },
                        {
                            // Sec. 7 — PMO/BAC Sec. consolidates all PPMPs into APP
                            id: "proc-app",
                            label: "Annual Procurement Plan (APP)",
                            link: "/procurement/pre-procurement/app",
                            permissionTypeId: [],
                        },
                        {
                            // DBM / Accountant issues Certificate of Availability of Funds
                            id: "proc-budget-certification",
                            label: "Budget & Fund Certification",
                            link: "/procurement/pre-procurement/budget-certification",
                            permissionTypeId: [],
                        },
                        {
                            // Sec. 17 — Required for highly technical / complex procurements
                            id: "proc-pre-procurement-conference",
                            label: "Pre-Procurement Conference",
                            link: "/procurement/pre-procurement/conference",
                            permissionTypeId: [],
                        },
                    ],
                },

                // ── PHASE 2 — BAC & Procurement Proper ───────────────────────
                // Sec. 11 — BAC composition & functions
                // Sec. 21 — Advertising & posting (PhilGEPS)
                // Sec. 22 — Pre-bid conference
                // Sec. 23 — Eligibility check (Sec. 23–24)
                // Sec. 25 — Bid submission & opening
                // ────────────────────────────────────────────────────────────

                {
                    // Sec. 11 — BAC, Secretariat, TWG formation
                    id: "proc-bac-management",
                    label: "BAC Management",
                    icon: "ri-group-2-line",
                    link: "/#",
                    parentId: "procurement",
                    isChildItem: true,
                    stateVariables: isProcBacManagement,
                    click: function (e) {
                        e.preventDefault();
                        setIsProcBacManagement(!isProcBacManagement);
                        setIscurrentState("ProcBacManagement");
                    },
                    childItems: [
                        {
                            // Sec. 11 — Chairperson, Vice-Chair, Members
                            id: "proc-bac-members",
                            label: "BAC Members",
                            link: "/procurement/bac/members",
                            permissionTypeId: [],
                        },
                        {
                            // Sec. 14 — BAC Secretariat
                            id: "proc-bac-secretariat",
                            label: "BAC Secretariat",
                            link: "/procurement/bac/secretariat",
                            permissionTypeId: [],
                        },
                        {
                            // Sec. 16 — TWG assists BAC on technical matters
                            id: "proc-twg",
                            label: "Technical Working Group (TWG)",
                            link: "/procurement/bac/twg",
                            permissionTypeId: [],
                        },
                        {
                            // Sec. 10 — Mode determination based on ABC thresholds
                            id: "proc-mode-of-procurement",
                            label: "Mode of Procurement",
                            link: "/procurement/bac/mode-of-procurement",
                            permissionTypeId: [],
                        },
                        {
                            // Sec. 37/38 — BAC Resolutions (award, failure, disqualification)
                            id: "proc-bac-resolutions",
                            label: "BAC Resolutions",
                            link: "/procurement/bac/resolutions",
                            permissionTypeId: [],
                        },
                    ],
                },

                {
                    // Sec. 21–25 — Advertisement, ITB/RFQ, pre-bid, submission & opening
                    id: "proc-advertisement-bidding",
                    label: "Advertisement & Bidding",
                    icon: "ri-auction-line",
                    link: "/#",
                    parentId: "procurement",
                    isChildItem: true,
                    stateVariables: isProcAdvertisement,
                    click: function (e) {
                        e.preventDefault();
                        setIsProcAdvertisement(!isProcAdvertisement);
                        setIscurrentState("ProcAdvertisement");
                    },
                    childItems: [
                        {
                            // Sec. 21 — ITB posted on PhilGEPS + newspaper (if required)
                            id: "proc-philgeps-postings",
                            label: "PhilGEPS Postings",
                            link: "/procurement/bidding/philgeps",
                            permissionTypeId: [],
                        },
                        {
                            // Sec. 21 — Invitation to Bid for public bidding
                            id: "proc-itb",
                            label: "Invitation to Bid (ITB)",
                            link: "/procurement/bidding/itb",
                            permissionTypeId: [],
                        },
                        {
                            // Sec. 53.9 — RFQ for small value procurement / shopping
                            id: "proc-rfq",
                            label: "Request for Quotation (RFQ)",
                            link: "/procurement/bidding/rfq",
                            permissionTypeId: [],
                        },
                        {
                            // Sec. 22 — Held ≥ 12 days after posting, ≥ 7 days before opening
                            id: "proc-pre-bid-conference",
                            label: "Pre-Bid Conference",
                            link: "/procurement/bidding/pre-bid-conference",
                            permissionTypeId: [],
                        },
                        {
                            // Sec. 22 — Responses to bidder clarifications
                            id: "proc-supplemental-bulletin",
                            label: "Supplemental Bid Bulletins",
                            link: "/procurement/bidding/supplemental-bulletins",
                            permissionTypeId: [],
                        },
                        {
                            // Sec. 25 — Two-envelope system; Env. 1 (eligibility + tech), Env. 2 (financial)
                            id: "proc-bid-submission",
                            label: "Bid Submission & Opening",
                            link: "/procurement/bidding/bid-submission",
                            permissionTypeId: [],
                        },
                    ],
                },

                // ── PHASE 3 — Bid Evaluation & Post-Qualification ────────────
                // Sec. 30 — Preliminary exam + detailed technical evaluation
                // Sec. 32 — Financial evaluation / ranking
                // Sec. 34 — Post-qualification of LCB
                // Sec. 35 — Failure of bidding
                // ────────────────────────────────────────────────────────────
                {
                    id: "proc-bid-evaluation",
                    label: "Bid Evaluation",
                    icon: "ri-file-search-line",
                    link: "/#",
                    parentId: "procurement",
                    isChildItem: true,
                    stateVariables: isProcBidEvaluation,
                    click: function (e) {
                        e.preventDefault();
                        setIsProcBidEvaluation(!isProcBidEvaluation);
                        setIscurrentState("ProcBidEvaluation");
                    },
                    childItems: [
                        {
                            // Sec. 30 — Eligibility screening + technical compliance check
                            id: "proc-technical-evaluation",
                            label: "Technical Evaluation",
                            link: "/procurement/evaluation/technical",
                            permissionTypeId: [],
                        },
                        {
                            // Sec. 32 — Opening Env. 2; ranking by price; LCB identified
                            id: "proc-financial-evaluation",
                            label: "Financial Evaluation",
                            link: "/procurement/evaluation/financial",
                            permissionTypeId: [],
                        },
                        {
                            // Sec. 34 — LCB's legal, technical & financial docs verified
                            id: "proc-post-qualification",
                            label: "Post-Qualification",
                            link: "/procurement/evaluation/post-qualification",
                            permissionTypeId: [],
                        },
                        {
                            // Sec. 35 — Grounds: <3 bidders, all fail, all disqualified, no compliant bid
                            id: "proc-bid-failure",
                            label: "Bid Failure & Re-Bidding",
                            link: "/procurement/evaluation/bid-failure",
                            permissionTypeId: [],
                        },
                    ],
                },

                // ── PHASE 4 — Award & Contract Execution ─────────────────────
                // Sec. 37 — BAC resolution, HoPE approval, NOA, contract signing, NTP
                // Sec. 39 — Performance security
                // Sec. 41 — Contract documents & review
                // Sec. 55 — Protest mechanism
                // ────────────────────────────────────────────────────────────
                {
                    id: "proc-award-contract",
                    label: "Award & Contract",
                    icon: "ri-contract-line",
                    link: "/#",
                    parentId: "procurement",
                    isChildItem: true,
                    stateVariables: isProcAwardContract,
                    click: function (e) {
                        e.preventDefault();
                        setIsProcAwardContract(!isProcAwardContract);
                        setIscurrentState("ProcAwardContract");
                    },
                    childItems: [
                        {
                            // Sec. 37 — BAC recommends award; forwarded to HoPE
                            id: "proc-resolution-of-award",
                            label: "Resolution of Award",
                            link: "/procurement/award/resolution",
                            permissionTypeId: [],
                        },
                        {
                            // Sec. 37 — NOA issued & posted on PhilGEPS within 3 days
                            id: "proc-notice-of-award",
                            label: "Notice of Award (NOA)",
                            link: "/procurement/award/noa",
                            permissionTypeId: [],
                        },
                        {
                            // Sec. 39 — Cash, manager's check, surety bond; 10 days from NOA
                            id: "proc-performance-bond",
                            label: "Performance Security",
                            link: "/procurement/award/performance-security",
                            permissionTypeId: [],
                        },
                        {
                            // Sec. 37 / 41 — Signed within 10 days of perf. security posting
                            id: "proc-contract-signing",
                            label: "Contract Signing",
                            link: "/procurement/award/contract-signing",
                            permissionTypeId: [],
                        },
                        {
                            // Sec. 37 — Issued within 7 days of contract signing
                            id: "proc-ntp",
                            label: "Notice to Proceed (NTP)",
                            link: "/procurement/award/ntp",
                            permissionTypeId: [],
                        },
                        {
                            // Sec. 55 — Protest filed with BAC; elevated to GPPB if needed
                            id: "proc-protest",
                            label: "Protest & Appeal",
                            link: "/procurement/award/protest",
                            permissionTypeId: [],
                        },
                    ],
                },

                // ── PHASE 5 — Contract Implementation & Monitoring ───────────
                // Sec. 63 — Inspection & acceptance
                // Sec. 68 — Liquidated damages for delays
                // Sec. 69 — Contract termination
                // ────────────────────────────────────────────────────────────
                {
                    id: "proc-implementation",
                    label: "Implementation",
                    icon: "ri-truck-line",
                    link: "/#",
                    parentId: "procurement",
                    isChildItem: true,
                    stateVariables: isProcImplementation,
                    click: function (e) {
                        e.preventDefault();
                        setIsProcImplementation(!isProcImplementation);
                        setIscurrentState("ProcImplementation");
                    },
                    childItems: [
                        {
                            // Sec. 37 — NTP triggers start of contract period
                            id: "proc-delivery",
                            label: "Delivery & Implementation",
                            link: "/procurement/implementation/delivery",
                            permissionTypeId: [],
                        },
                        {
                            // Sec. 63 — Inspection Committee + end-user; IAR / IIRUP
                            id: "proc-inspection-acceptance",
                            label: "Inspection & Acceptance",
                            link: "/procurement/implementation/inspection",
                            permissionTypeId: [],
                        },
                        {
                            // NGAS / COA — DV → ORS → payment release
                            id: "proc-disbursement-voucher",
                            label: "Disbursement Voucher (DV)",
                            link: "/procurement/implementation/dv",
                            permissionTypeId: [],
                        },
                        {
                            // Sec. 68 — 1/10 of 1% per day of delay deducted from payment
                            id: "proc-liquidated-damages",
                            label: "Liquidated Damages",
                            link: "/procurement/implementation/liquidated-damages",
                            permissionTypeId: [],
                        },
                        {
                            // Sec. 69 — Grounds: unsatisfactory performance, force majeure, etc.
                            id: "proc-contract-termination",
                            label: "Contract Termination",
                            link: "/procurement/implementation/termination",
                            permissionTypeId: [],
                        },
                        {
                            // Final acceptance, return of perf. bond, COA audit clearance
                            id: "proc-contract-completion",
                            label: "Contract Completion",
                            link: "/procurement/implementation/completion",
                            permissionTypeId: [],
                        },
                    ],
                },

                // ── Reports & Settings ───────────────────────────────────────
                {
                    id: "proc-reports",
                    label: "Reports",
                    icon: "ri-article-line",
                    link: "/procurement/reports",
                    parentId: "procurement",
                    permissionTypeId: [],
                },
                {
                    id: "proc-settings",
                    label: "Settings",
                    icon: "ri-settings-2-fill",
                    link: "/procurement/settings",
                    parentId: "procurement",
                    permissionTypeId: [],
                },
            ],
        },
    ];
}